import type { BaseOrder } from 'models/Order';
import type { Adjustment, AdjustmentType } from 'lib/api/ecommerce/schema';

export const getOrderAdjustment = (
  order: BaseOrder,
  type: AdjustmentType
): Adjustment | undefined => {
  return order.adjustments.find((k) => k.type === type);
};
